import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths } from '../../models/enums';
import useMutation from '../useMutation';

import MutationKeys from './keys';
import { ABTestInsightMetrics } from './useGetABTestInsights';

export type DeclareABTestWinnerInput = {
    campaignId: string;
    winnerSendId: number;
    abTestInsights: Record<string, ABTestInsightMetrics>;
};

export type DeclareABTestWinnerResponse = {
    success: boolean;
    message?: string;
};

/**
 * Declares the winner of an A/B test for a campaign.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useDeclareABTestWinner = (
    mutateOptions?: UseMutationOptions<DeclareABTestWinnerResponse, Error, DeclareABTestWinnerInput>
) =>
    useMutation<DeclareABTestWinnerInput, DeclareABTestWinnerResponse>(
        MutationKeys.DECLARE_AB_TEST_WINNER,
        CuredApiPaths.CAMPAIGNS_AB_TEST_DECLARE_WINNER,
        mutateOptions
    );

export default useDeclareABTestWinner;
